import { t } from 'i18next';

import { ErrorResponseErrorItemCodeFileVersion } from '../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeFileVersion, string> => ({
  'file_version:not_found':
    t?.('fileVersion.notFound', { ns: 'apiErrorCodes' }) ?? 'Filversionen kunde inte hittas.',
  'file_version:user_unauthorized':
    t?.('fileVersion.userUnauthorized', { ns: 'apiErrorCodes' }) ??
    'Du har inte åtkomst till aktuell filversion.',
  'file_version:sim_already_exists':
    t?.('fileVersion.simAlreadyExists', { ns: 'apiErrorCodes' }) ??
    'Filversionen har redan bearbetats.',
  'file_version:sim_unsupported':
    t?.('fileVersion.simUnsupported', { ns: 'apiErrorCodes' }) ??
    'Filversionen har redan bearbetats.',
});
